import React, {} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {
  SIDEBAR_NAVIGATION_CABINET_BUTTONS, SQFT_APPLIANCES,
  SQFT_APPLIANCES_WITH_SUBMENU,
} from "../../../../constants";
import {setSQFTMenuOpened} from "../../../../../../actions/sqftMenuFunctions";
import {createApplianceOnTheWorkspace} from "../../../../helpers/featureHelper";
import {checkIfLookFeaturesReceived} from "../../../../../../api/look-api";
import {getCurrentLayout} from "../../../../../appLayout";
import {loaderDisable, loaderEnable} from "../../../../../ui/loaderView";
import {isSFTCabinetsGroup} from "../../../../helpers/sqftNavigationHelper";

const SqftNavAppliancesItem = (props) => {
  const {itemName} = props;
  const {setSQFTMenuOpened} = props;

  const itemClick = async (event) => {
    console.log("itemName", itemName);
    event.preventDefault();
    event.stopPropagation();
    loaderEnable();
    const partIdMap = {
      [SIDEBAR_NAVIGATION_CABINET_BUTTONS.centerIsland]: 'countertop',
      [SQFT_APPLIANCES.refrigerator]: 'fridge',
      [SQFT_APPLIANCES.stovetop]: 'stove',
    };

    const getFeatureGroupByItemName = async (layout, itemName) => {
      const partId = partIdMap[itemName] || itemName;
      const featureGroup = layout.getFeatureGroupByPartId(partId);

      if (featureGroup && !featureGroup.allFeaturesReceived) {
        await checkIfLookFeaturesReceived(featureGroup);
      }

      return featureGroup;
    };

    const getNavItemsWithThirdPartyAR3DUrls = (layout, featureGroup) => {
      const navItems = layout.designNavigationItems(
        { part: featureGroup },
        [],
        "",
        featureGroup.activeFeature,
        "all",
        [],
        { firstFeature: null, firstConditions: null },
      );

      return navItems.filter(navItem => navItem.part.dbFeature.thirdPartyAR3DUrls);
    };

    const processItemSelection = async (itemName) => {
      if (!SQFT_APPLIANCES_WITH_SUBMENU.includes(itemName)) {
        createApplianceOnTheWorkspace(itemName);
        return;
      }

      const layout = getCurrentLayout();
      const featureGroup = await getFeatureGroupByItemName(layout, itemName);

      if (!featureGroup) {
        createApplianceOnTheWorkspace(itemName);
        return;
      }

      const isCabinet = isSFTCabinetsGroup();
      const filteredNavItems = getNavItemsWithThirdPartyAR3DUrls(layout, featureGroup);

      //enable appliance features submenu only for the cabinets
      if (filteredNavItems.length > 0 && isCabinet) {
        setSQFTMenuOpened(itemName);
      } else {
        console.log(featureGroup.partName + ". There are no features with attached 3dModel in this featuregroup (thirdPartyAR3DUrls is empty)");
        createApplianceOnTheWorkspace(itemName);
      }
    };

    await processItemSelection(itemName).catch(console.error);
    loaderDisable();
  };

  return (
    <li className="lightbox-option-round lightbox-option-round--appliances">
      <a href="#" className={"lightbox-option-round-loader-edge icon-" + itemName} title={itemName + " placeholder"}
         id={"placeholder_" + itemName}
         onClick={itemClick}>
        <span className="lightbox-description-text">
          <FormattedMessage id={"sqft.navigation.appliances." + itemName}/>
        </span>
      </a>
    </li>
  )
};

const mapStateToProps = () => {
  return {}
};

const mapDispatchToProps = {
  setSQFTMenuOpened
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftNavAppliancesItem);
